import React from 'react';
import classNames from 'classnames';
import { defaultTheme, makeStyles } from "../../styles/index";
import { useTheme } from "../../hooks/useTheme";
import { RadioButtonIconBorder } from "./RadioButtonIconBorder";
import { RadioButtonIconInner } from "./RadioButtonIconInner";
// ボタンサイズ
var RADIO_BUTTON_SIZE = 30;
var RADIO_BUTTON_INNER_SIZE = 20;
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: 30,
        height: 30,
        position: 'relative',
        '& $outerLayer': {
            transition: theme.transitions.create('color', {
                duration: theme.transitions.duration.shorter,
            }),
        },
        '& $innerLayer': {
            transition: theme.transitions.create(['transform', 'color'], {
                duration: theme.transitions.duration.shorter,
            }),
        },
        // 中の丸のサイズ制御
        '&$unchecked $innerLayer': { transform: 'scale(0)' },
        '&$unchecked$hover $innerLayer': { transform: 'scale(1)' },
        '&$unchecked$active $innerLayer': { transform: 'scale(1)' },
        '&$checked $innerLayer': { transform: 'scale(1)' },
    },
    light: {
        // checkedのスタイル
        '&$checked': {
            '& $outerLayer': { color: theme.palette.primary.main },
            '& $innerLayer': { color: theme.palette.primary.main },
        },
        '&$checked$hover': {
            '& $outerLayer': { color: theme.palette.primary.main },
            '& $innerLayer': { color: theme.palette.primary[200] },
        },
        // uncheckedのスタイル
        '&$unchecked': {
            '& $outerLayer': { color: theme.palette.light.text.primary },
            '& $innerLayer': { color: theme.palette.primary[50] },
        },
        '&$unchecked$hover': {
            '& $outerLayer': { color: theme.palette.primary.main },
            '& $innerLayer': { color: theme.palette.primary[50] },
        },
        // 以下、checked/unchecked共通のスタイル。
        // 詳細度を上げるためそれぞれ$checked/$uncheckedを指定している。
        // disabledのスタイル。詳細度を上げるため$checked/$uncheckedを指定している。
        '&$disabled$checked, &$disabled$unchecked': {
            '& $outerLayer': { color: theme.palette.light.action.disabled },
            '& $innerLayer': { color: theme.palette.light.action.disabled },
        },
        // activeのスタイル
        '&$active$checked, &$active$unchecked': {
            '& $outerLayer': { color: theme.palette.primary.main },
            '& $innerLayer': { color: theme.palette.primary[700] },
        },
    },
    dark: {
        // checkedのスタイル
        '&$checked': {
            '& $outerLayer': { color: theme.palette.primary[100] },
            '& $innerLayer': { color: theme.palette.primary[300] },
        },
        '&$checked$hover': {
            '& $outerLayer': { color: theme.palette.primary[100] },
            '& $innerLayer': { color: theme.palette.primary[200] },
        },
        // uncheckedのスタイル
        '&$unchecked': {
            '& $outerLayer': { color: theme.palette.dark.text.primary },
            '& $innerLayer': { color: theme.palette.dark.background.paper },
        },
        '&$unchecked$hover': {
            '& $outerLayer': { color: theme.palette.primary[100] },
            '& $innerLayer': { color: theme.palette.dark.background.paper },
        },
        // 以下、checked/unchecked共通のスタイル。
        // 詳細度を上げるためそれぞれ$checked/$uncheckedを指定している。
        // disabledのスタイル。
        '&$disabled$checked, &$disabled$unchecked': {
            '& $outerLayer': { color: theme.palette.dark.action.disabled },
            '& $innerLayer': { color: theme.palette.dark.action.disabled },
        },
        // activeのスタイル
        '&$active$checked, &$active$unchecked': {
            '& $outerLayer': { color: theme.palette.primary[100] },
            '& $innerLayer': { color: theme.palette.primary[600] },
        },
    },
    center: {
        position: 'absolute',
        margin: 'auto',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    },
    outerLayer: {},
    innerLayer: {},
    checked: {},
    unchecked: {},
    hover: {},
    active: {},
    disabled: {},
}); }, { name: 'SnRadioButtonIcon' });
/**
 * ラジオボタンのアイコンコンポーネント。
 */
export var RadioButtonIcon = function (props) {
    var _a;
    var checked = props.checked, disabled = props.disabled, hover = props.hover, active = props.active, light = props.light, dark = props.dark;
    var classes = useStyles(props);
    var theme = useTheme({ dark: dark, light: light });
    var rootClassNames = classNames(classes.root, classes[theme.type], (_a = {},
        _a[classes.checked] = checked,
        _a[classes.unchecked] = !checked,
        _a[classes.disabled] = disabled,
        _a[classes.active] = active && !disabled,
        _a[classes.hover] = hover && !active && !disabled,
        _a));
    return (React.createElement("span", { className: rootClassNames },
        React.createElement(RadioButtonIconBorder, { borderWidth: defaultTheme.shape.borderWidth.normal, size: RADIO_BUTTON_SIZE, className: classNames(classes.outerLayer, classes.center) }),
        React.createElement(RadioButtonIconInner, { size: RADIO_BUTTON_SIZE, innerSize: RADIO_BUTTON_INNER_SIZE, className: classNames(classes.innerLayer, classes.center) })));
};
